export const columnsConfig = {
  // Actions
  actions: {
    title: "Actions",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: null,
    type: "actions",
    category: "Actions",
    filterable: false,
  },

  // Identification
  catalogue: {
    groups: ["default"],
    title: "Catalogue",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "catalogue",
    type: "badge",
    category: "Identification",
    filterable: {
      filterKey: "catalogue",
      filterType: "select",
      placeholder: "Sélectionner un catalogue",
      options: "state.constant.items.CATALOG_HITECH",
    },
  },

  statut: {
    groups: ["default"],
    title: "Statut",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "statut",
    type: "badge",
    category: "Identification",
    filterable: {
      filterKey: "statuts",
      filterType: "select-multiple",
      placeholder: "Sélectionner des statuts",
      options: "state.constant.items.FLOTTE.STATUTS_VEHICULE",
      helpers: [
        {
          label: "Statuts 5",
          compute: (options) =>
            (options || [])
              .filter((o) => String(o.id).startsWith("5"))
              .map((o) => o.id),
        },
        {
          label: "Statuts 6",
          compute: (options) =>
            (options || [])
              .filter((o) => String(o.id).startsWith("6"))
              .map((o) => o.id),
        },
        {
          label: "Statuts 5+6",
          compute: (options) =>
            (options || [])
              .filter(
                (o) =>
                  String(o.id).startsWith("6") || String(o.id).startsWith("5"),
              )
              .map((o) => o.id),
        },
      ],
    },
  },
  date_dernier_statut: {
    title: "Date dernier statut",
    visible: false,
    path: "date_dernier_statut",
    type: "date",
    category: "Suivi",
    filterable: {
      filterKey: "date_dernier_statut",
      filterType: "date-range",
      placeholder: "Choisissez une période",
    },
  },
  type_client: {
    groups: ["default"],
    title: "Secteur",
    visible: true,

    path: "contrat.type_client",
    type: "text",
    category: "Identification",
    filterable: {
      filterKey: "types_client",
      filterType: "select-multiple",
      placeholder: "Sélectionner des secteurs",
      options: "state.constant.items.FLOTTE.TYPES_CLIENT",
    },
  },
  immatriculation: {
    groups: ["default"],
    title: "Immat.",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "identification.immatriculation",
    type: "immatriculation",
    category: "Identification",
    filterable: {
      filterKey: "immatriculations",
      filterType: "tag-input",
      placeholder: "Exacte ou partielle (AB, AB123, AB123CD, ...)",
    },
  },
  marque: {
    groups: ["default"],
    title: "Marque",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "identification.marque",
    type: "brand",
    category: "Identification",
    filterable: {
      filterKey: "marques",
      filterType: "tag-input",
      placeholder: "Ajouter une marque (ex: Renault)",
    },
  },
  modele: {
    groups: ["default"],
    title: "Modèle",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "identification.modele",
    type: "text",
    category: "Identification",
    filterable: {
      filterKey: "modeles",
      filterType: "tag-input",
      placeholder: "Ajouter un modèle (ex: Clio)",
    },
  },
  finition: {
    groups: ["default"],
    title: "Finition",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "identification.finition",
    type: "condensed",
    category: "Identification",
    filterable: {
      filterKey: "finitions",
      filterType: "tag-input",
      placeholder: "Ajouter une finition",
    },
  },
  carburant: {
    title: "Carburant",
    visible: false,
    visibleVO: false,
    isVO: true,
    isVO531: true,
    path: "identification.carburant",
    type: "condensed",
    category: "Identification",
    filterable: {
      filterKey: "carburants",
      filterType: "select-multiple",
      placeholder: "Sélectionner des carburants",
      options: "state.constant.items.FLOTTE.CARBURANTS",
    },
  },
  type: {
    title: "Type",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "type",
    type: "badge",
    category: "Identification",
    filterable: {
      filterKey: "types_vehicule",
      filterType: "select-multiple",
      placeholder: "Sélectionner des types de véhicule",
      options: "state.constant.items.FLOTTE.TYPES_VEHICULE",
    },
  },
  code_vin: {
    title: "Code VIN",
    visible: false,
    visibleVO: false,
    isVO: true,
    isVO531: true,
    path: "identification.code_vin",
    type: "text",
    category: "Identification",
    filterable: false,
  },
  date_mise_en_circulation: {
    title: "Mise en circulation",
    visible: false,
    visibleVO: false,
    isVO: true,
    isVO531: true,
    path: "identification.date_mise_en_circulation",
    type: "date",
    category: "Identification",
    filterable: false,
  },

  // Contrat
  client: {
    groups: ["default"],
    title: "Client",
    visible: true,

    path: "contrat.intitule_client",
    type: "condensed",
    category: "Contrat",
    filterable: {
      filterKey: "client",
      filterType: "text",
      placeholder: "Nom ou raison sociale",
    },
  },
  commercial: {
    title: "Commercial",
    visible: false,
    path: "contrat.commercial",
    type: "text",
    category: "Contrat",
    filterable: {
      filterKey: "commercial",
      filterType: "text",
      placeholder: "Nom ou prénom du commercial",
    },
  },
  financeur: {
    title: "Financeur",
    visible: false,
    path: "contrat.financeur",
    type: "text",
    category: "Contrat",
    filterable: false,
  },
  numero_dossier: {
    title: "N° Dossier",
    visible: false,
    path: "contrat.numero_dossier",
    type: "text",
    category: "Contrat",
    filterable: false,
  },
  numero_comptable: {
    title: "N° Comptable",
    visible: false,
    path: "contrat.numero_comptable",
    type: "text",
    category: "Contrat",
    filterable: false,
  },
  duree: {
    groups: ["default"],
    title: "Durée",
    visible: false,
    path: "contrat.duree_mois",
    type: "duration",
    category: "Contrat",
    filterable: false,
  },
  km: {
    groups: ["default"],
    title: "Km",
    visible: false,
    path: "contrat.kilometrage",
    type: "distance",
    category: "Contrat",
    filterable: false,
  },
  duree_derniere_enregistree: {
    groups: ["default"],
    title: "Dernière durée",
    visible: true,

    path: "duree_reelle",
    type: "duration",
    category: "Loi roulage",
    filterable: false,
    isSync: true,
  },
  km_dernier_enregistre: {
    groups: ["default"],
    title: "Dernier Km",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "km_reel",
    type: "distance",
    category: "Loi roulage",
    filterable: false,
    isSync: true,
  },
  date_dernier_km: {
    groups: ["default"],
    title: "Date dernier km",
    visible: true,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "date_dernier_km",
    type: "date",
    category: "Loi roulage",
    filterable: false,
    isSync: true,
  },

  derniere_date_retour: {
    groups: ["default"],
    title: "⭐️ Dernière date retour",
    visible: true,

    path: "derniere_date_retour",
    type: "date",
    category: "Suivi",
    filterable: {
      filterKey: "derniere_date_retour",
      filterType: "date-range",
      placeholder: "Choisissez une période",
    },
  },
  // Position & Localisation
  date_derniere_position: {
    title: "Date dernière position",
    visible: false,
    path: "date_derniere_position",
    type: "date",
    category: "Suivi",
    filterable: false,
  },
  derniere_position: {
    title: "Dernière position",
    visible: false,
    visibleVO: true,
    isVO531: true,
    isVO: true,
    path: "derniere_position",
    type: "text",
    category: "Suivi",
    filterable: {
      filterKey: "positions",
      filterType: "select-multiple",
      placeholder: "Sélectionner des positions",
      options: "state.constant.items.FLOTTE.POSITIONS",
    },
  },
  date_derniere_localisation: {
    title: "Date dernière localisation",
    visible: false,
    path: "date_derniere_localisation",
    type: "date",
    category: "Suivi",
    filterable: false,
  },
  derniere_localisation: {
    title: "Dernière localisation",
    visible: false,
    path: "derniere_localisation",
    type: "text",
    category: "Suivi",
    filterable: false,
  },

  debut_contrat: {
    groups: ["default"],
    title: "Début Contrat",
    visible: true,
    isVO: true,
    visibleVO: true,
    isVO531: true,
    path: "contrat.date_debut",
    type: "date_debut",
    category: "Contrat",
    filterable: {
      filterKey: "contrat_date_debut",
      filterType: "date-range",
      placeholder: "Choisissez une période",
    },
  },
  fin_contrat: {
    groups: ["default"],
    title: "Fin Contrat",
    visible: true,
    path: "contrat.date_fin_prevue",
    type: "date_fin",
    category: "Contrat",
    filterable: {
      filterKey: "contrat_date_fin",
      filterType: "date-range",
      placeholder: "Choisissez une période",
    },
    isSync: true,
  },

  date_prolongation: {
    title: "Date Prolongation",
    visible: false,
    path: "contrat.date_prolongation",
    type: "date",
    category: "Contrat",
    filterable: {
      filterKey: "contrat_date_prolongation",
      filterType: "date-range",
      placeholder: "Choisissez une période",
    },
    isSync: true,
  },

  // Financier
  taux_financement: {
    groups: ["contrat"],
    title: "Taux Financement",
    visible: false,
    path: "contrat.taux_financement_retenu",
    type: "percentage",
    category: "Financier",
    filterable: false,
  },
  loyer_financier: {
    groups: ["contrat"],
    title: "Loyer Financier HT",
    visible: false,
    path: "contrat.calcul_loyer_financier",
    type: "currency",
    category: "Financier",
    filterable: false,
  },
  premier_loyer_majore: {
    groups: ["contrat"],
    title: "Premier Loyer Majoré HT",
    visible: false,
    path: "contrat.premier_loyer_majore",
    type: "currency",
    category: "Financier",
    filterable: false,
  },
  total_loyer_ht: {
    groups: ["contrat"],
    title: "Total Loyer HT",
    visible: false,
    path: "contrat.total_loyer_ht",
    type: "currency",
    category: "Financier",
    filterable: false,
  },
  total_loyer_ttc: {
    groups: ["contrat"],
    title: "Total Loyer TTC",
    visible: false,
    path: "contrat.total_loyer_ttc",
    type: "currency",
    category: "Financier",
    filterable: false,
  },
  assurance_ht: {
    groups: ["contrat"],
    title: "Assurance HT",
    visible: false,
    path: "contrat.assurance_retenue_ht",
    type: "currency",
    category: "Financier",
    filterable: false,
  },
  entretien_ht: {
    groups: ["contrat"],
    title: "Entretien HT",
    visible: false,
    path: "contrat.entretien_retenu_ht",
    type: "currency",
    category: "Financier",
    filterable: false,
  },
  pneumatiques_ht: {
    groups: ["contrat"],
    title: "Pneumatiques HT",
    visible: false,
    path: "contrat.pneumatiques_ht",
    type: "currency",
    category: "Financier",
    filterable: false,
  },
  vehicule_de_remplacement: {
    groups: ["contrat"],
    title: "Véhicule de Remplacement HT",
    visible: false,
    path: "contrat.vehicule_de_remplacement",
    type: "currency",
    category: "Financier",
    filterable: false,
  },
  assurance_perte_financiere: {
    groups: ["contrat"],
    title: "Assurance Perte Financière HT",
    visible: false,
    path: "contrat.assurance_perte_financiere_retenue",
    type: "currency",
    category: "Financier",
    filterable: false,
  },

  // Commande
  prix_catalogue_ttc: {
    title: "Prix Catalogue TTC",
    visible: false,
    path: "commande.prix_catalogue_ttc",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  montant_investissement_ht: {
    groups: ["contrat"],
    title: "Prix véhicule HT",
    visible: false,
    path: "commande.montant_investissement_ht",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  montant_investissement_hors_bonus_ht: {
    title: "Montant Investissement Hors Bonus HT",
    visible: false,
    path: "commande.montant_investissement_hors_bonus_ht",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  montant_remise: {
    groups: ["contrat"],
    title: "Montant Remise HT",
    visible: false,
    path: "commande.montant_remise",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  taux_remise: {
    groups: ["contrat"],
    title: "Taux Remise",
    visible: false,
    path: "commande.montant_remise_appliquee",
    type: "percentage",
    category: "Commande",
    filterable: false,
  },
  prix_final_ttc: {
    groups: ["contrat"],
    title: "Prix Final TTC",
    visible: false,
    path: "commande.prix_final_ttc",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  prix_net_ttc: {
    groups: ["contrat"],
    title: "Prix Net TTC",
    visible: false,
    path: "commande.prix_net_ttc",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  marge_ttc: {
    groups: ["contrat"],
    title: "Marge HT",
    visible: false,
    path: "commande.marge_ttc",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  marge_commerciale: {
    title: "Marge Commerciale HT",
    visible: false,
    path: "commande.marge_commerciale_retenue",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  frais_carte_grise: {
    title: "Frais Carte Grise HT",
    visible: false,
    path: "commande.frais_carte_grise",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  bonus_ecologique: {
    title: "Bonus Écologique HT",
    visible: false,
    path: "commande.bonus_ecologique",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  malus_ecologique: {
    title: "Malus Écologique HT",
    visible: false,
    path: "commande.malus_ecologique",
    type: "currency",
    category: "Commande",
    filterable: false,
  },
  date_commande: {
    title: "Date Commande",
    visible: false,
    path: "commande.date_commande",
    type: "date",
    category: "Commande",
    filterable: false,
  },
  date_livraison_prevue: {
    title: "Livraison Prévue",
    visible: false,
    path: "commande.date_livraison_prevue",
    type: "date",
    category: "Commande",
    filterable: false,
  },
  date_livraison_effective: {
    title: "Livraison Effective",
    visible: false,
    path: "commande.date_livraison_effective",
    type: "date",
    category: "Commande",
    filterable: false,
  },

  // Retour
  date_retour_definitive: {
    title: "Date Retour Définitive",
    visible: false,
    path: "contrat.retour.date_retour_definitive",
    type: "date",
    category: "Retour",
    filterable: false,
  },
  date_rachat: {
    title: "Date Rachat",
    visible: false,
    path: "contrat.retour.date_rachat",
    type: "date",
    category: "Retour",
    filterable: false,
  },
  kilometrage_retour: {
    title: "Kilométrage Retour",
    visible: false,
    path: "contrat.retour.kilometrage_retour",
    type: "distance",
    category: "Retour",
    filterable: false,
  },
  prix_rachat_financeur_ht: {
    title: "Prix Rachat Financeur HT",
    visible: false,
    path: "contrat.retour.prix_rachat_financeur_ht",
    type: "currency",
    category: "Retour",
    filterable: false,
  },
  taux_vr_retour: {
    title: "Taux VR Retour",
    visible: false,
    path: "contrat.retour.taux_valeur_residuelle_retour_definitif",
    type: "percentage",
    category: "Retour",
    filterable: false,
  },
  montant_restitution_ht: {
    title: "Montant Restitution HT",
    visible: false,
    path: "contrat.retour.montant_restitution_recalculee_ht",
    type: "currency",
    category: "Retour",
    filterable: false,
  },
  frais_rupture_ht: {
    title: "Frais Rupture HT",
    visible: false,
    path: "contrat.retour.montant_devis_ou_facture_rupture_ht",
    type: "currency",
    category: "Retour",
    filterable: false,
  },
  km_supplementaire_ht: {
    title: "KM Suppl. HT",
    visible: false,
    path: "contrat.retour.montant_kilometrage_supplementaire_ht",
    type: "currency",
    category: "Retour",
    filterable: false,
  },
  frais_remise_en_etat_ht: {
    title: "Frais Remise en État HT",
    visible: false,
    path: "contrat.retour.frais_remise_en_etat_ht",
    type: "currency",
    category: "Retour",
    filterable: false,
  },

  // Vente
  date_vente: {
    title: "Date de Vente",
    visible: false,
    path: "vente.date",
    type: "date",
    category: "Vente",
    filterable: false,
  },
  acheteur: {
    title: "Acheteur",
    visible: false,
    path: "vente.acheteur",
    type: "condensed",
    category: "Vente",
    filterable: false,
  },
  marges_vente: {
    title: "Marges Vente HT",
    visible: false,
    path: "vente.marges",
    type: "currency",
    category: "Vente",
    filterable: false,
  },

  // === MOUVEMENTS CONTRAT ===
  mouvement_contrat_date_retour: {
    title: "Date Retour (prévue)",
    badge: "Contrat",
    visible: false,
    path: "contrat.date_fin_prevue",
    type: "date",
    category: "Mvt. Contrat",
    filterable: false,
  },
  mouvement_contrat_duree: {
    title: "Durée",
    badge: "Contrat",
    visible: false,
    path: "mouvement_contrat.duree",
    type: "duration",
    category: "Mvt. Contrat",
    filterable: false,
  },
  mouvement_contrat_km: {
    title: "Kilométrage",
    badge: "Contrat",
    visible: false,
    path: "mouvement_contrat.km",
    type: "distance",
    category: "Mvt. Contrat",
    filterable: false,
  },
  mouvement_contrat_taux_vr: {
    groups: ["contrat"],
    title: "Taux VR",
    badge: "Contrat",
    visible: false,
    path: "mouvement_contrat.taux_vr",
    type: "percentage",
    category: "Mvt. Contrat",
    filterable: false,
  },
  mouvement_contrat_montant_vr: {
    groups: ["contrat"],
    title: "Montant VR HT",
    badge: "Contrat",
    visible: false,
    path: "mouvement_contrat.montant_vr",
    type: "currency",
    category: "Mvt. Contrat",
    filterable: false,
  },
  mouvement_contrat_valeur_theorique: {
    groups: ["vo"],
    title: "Valeur Théorique HT",
    badge: "Contrat",
    visible: false,
    path: "mouvement_contrat.valeur_theorique",
    type: "currency",
    category: "Mvt. Contrat",
    filterable: false,
  },
  // mouvement_contrat_indemnites: {
  //   title: "Indemnités",
  //   badge: "Contrat",
  //   visible: false,
  //   path: "mouvement_contrat.indemnites",
  //   type: "currency",
  //   category: "Mvt. Contrat",
  //   filterable: false,
  // },
  // mouvement_contrat_km_sup: {
  //   title: "KM Supplémentaires",
  //   badge: "Contrat",
  //   visible: false,
  //   path: "mouvement_contrat.km_sup",
  //   type: "distance",
  //   category: "Mvt. Contrat",
  //   filterable: false,
  // },
  // mouvement_contrat_frais_remise_en_etat: {
  //   title: "Frais Remise en État",
  //   badge: "Contrat",
  //   visible: false,
  //   path: "mouvement_contrat.frais_remise_en_etat",
  //   type: "currency",
  //   category: "Mvt. Contrat",
  //   filterable: false,
  // },
  // mouvement_contrat_cout_remise_en_etat_facture: {
  //   title: "Coût Remise en État Facturé",
  //   badge: "Contrat",
  //   visible: false,
  //   path: "mouvement_contrat.cout_remise_en_etat_facture",
  //   type: "currency",
  //   category: "Mvt. Contrat",
  //   filterable: false,
  // },

  // === MOUVEMENTS PROLONGATION ===
  mouvement_prolongation_date_retour: {
    title: "Date Retour",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.date_retour",
    type: "date",
    category: "Mvt. Prolongation",
    filterable: false,
  },
  mouvement_prolongation_duree: {
    title: "Durée",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.duree",
    type: "duration",
    category: "Mvt. Prolongation",
    filterable: false,
  },
  mouvement_prolongation_km: {
    title: "Kilométrage",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.km",
    type: "distance",
    category: "Mvt. Prolongation",
    filterable: false,
  },
  mouvement_prolongation_taux_vr: {
    title: "Taux VR",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.taux_vr",
    type: "percentage",
    category: "Mvt. Prolongation",
    filterable: false,
  },
  mouvement_prolongation_montant_vr: {
    title: "Montant VR HT",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.montant_vr",
    type: "currency",
    category: "Mvt. Prolongation",
    filterable: false,
  },
  mouvement_prolongation_valeur_theorique: {
    title: "Valeur Théorique HT",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.valeur_theorique",
    type: "currency",
    category: "Mvt. Prolongation",
    filterable: false,
  },
  mouvement_prolongation_indemnites: {
    title: "Indemnités HT",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.indemnites",
    type: "currency",
    category: "Mvt. Prolongation",
    filterable: false,
  },
  mouvement_prolongation_km_sup: {
    title: "KM Suppl.",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.km_sup",
    type: "distance",
    category: "Mvt. Prolongation",
    filterable: false,
  },
  mouvement_prolongation_frais_remise_en_etat: {
    title: "Frais Remise en État HT",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.frais_remise_en_etat",
    type: "currency",
    category: "Mvt. Prolongation",
    filterable: false,
  },
  mouvement_prolongation_cout_remise_en_etat_facture: {
    title: "Coût Remise en État Facturé HT",
    badge: "Prolong.",
    visible: false,
    path: "mouvement_prolongation.cout_remise_en_etat_facture",
    type: "currency",
    category: "Mvt. Prolongation",
    filterable: false,
  },

  // === MOUVEMENTS FIN RÉELLE ===
  mouvement_fin_reelle_date_retour: {
    title: "Date Retour",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.date_retour",
    type: "date",
    category: "Mvt. Fin réelle",
    filterable: false,
    isSync: true,
  },
  mouvement_fin_reelle_duree: {
    title: "Durée",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.duree",
    type: "duration",
    category: "Mvt. Fin réelle",
    filterable: false,
  },
  mouvement_fin_reelle_km: {
    title: "Kilométrage",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.km",
    type: "distance",
    category: "Mvt. Fin réelle",
    filterable: false,
  },
  mouvement_fin_reelle_taux_vr: {
    title: "Taux VR",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.taux_vr",
    type: "percentage",
    category: "Mvt. Fin réelle",
    filterable: false,
  },
  mouvement_fin_reelle_montant_vr: {
    title: "Montant VR HT",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.montant_vr",
    type: "currency",
    category: "Mvt. Fin réelle",
    filterable: false,
  },
  mouvement_fin_reelle_valeur_theorique: {
    groups: ["vo"],
    title: "Valeur Théorique HT",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.valeur_theorique",
    type: "currency",
    category: "Mvt. Fin réelle",
    filterable: false,
  },
  mouvement_fin_reelle_indemnites: {
    title: "Indemnités HT",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.indemnites",
    type: "currency",
    category: "Mvt. Fin réelle",
    filterable: false,
  },
  mouvement_fin_reelle_km_sup: {
    title: "KM Suppl.",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.km_sup",
    type: "distance",
    category: "Mvt. Fin réelle",
    filterable: false,
  },
  mouvement_fin_reelle_frais_remise_en_etat: {
    title: "Frais Remise en État HT",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.frais_remise_en_etat",
    type: "currency",
    category: "Mvt. Fin réelle",
    filterable: false,
  },
  mouvement_fin_reelle_cout_remise_en_etat_facture: {
    groups: ["bb"],
    title: "Coût Remise en État Facturé HT",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.cout_remise_en_etat_facture",
    type: "currency",
    category: "Mvt. Fin réelle",
    filterable: false,
  },

  // === MOUVEMENTS FIN RÉELLE — RME ===
  mouvement_fin_reelle_km_sup_devis: {
    groups: ["bb"],
    title: "KM Sup. HT (devis)",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.montant_km_supp_devis",
    type: "currency",
    category: "Mvt. Fin réelle frais",
    filterable: false,
  },
  mouvement_fin_reelle_km_sup_definitif: {
    groups: ["bb"],
    title: "KM Sup. HT (définitif)",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.montant_km_supp_definitif",
    type: "currency",
    category: "Mvt. Fin réelle frais",
    filterable: false,
  },
  mouvement_fin_reelle_km_sup_facture: {
    groups: ["bb"],
    title: "KM Sup. HT (facturé)",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.montant_km_supp_facture",
    type: "currency",
    category: "Mvt. Fin réelle frais",
    filterable: false,
  },
  mouvement_fin_reelle_indemnites_devis: {
    groups: ["bb"],
    title: "Indemnités HT (devis)",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.indemnites_devis",
    type: "currency",
    category: "Mvt. Fin réelle frais",
    filterable: false,
  },
  mouvement_fin_reelle_indemnites_definitif: {
    groups: ["bb"],
    title: "Indemnités HT (définitif)",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.indemnites_definitif",
    type: "currency",
    category: "Mvt. Fin réelle frais",
    filterable: false,
  },
  mouvement_fin_reelle_indemnites_facture: {
    groups: ["bb"],
    title: "Indemnités HT (facturé)",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.indemnites_facture",
    type: "currency",
    category: "Mvt. Fin réelle frais",
    filterable: false,
  },
  mouvement_fin_reelle_frais_rme_devis: {
    groups: ["bb"],
    title: "Frais RME HT (devis)",
    badge: "Fin réelle",
    visible: false,
    // La clé API `frais_remise_en_etat_devis` est renommée en `frais_remise_en_etat`
    // par useFlotte.js (fieldMapping) — d'où ce path.
    path: "mouvement_fin_reelle.frais_remise_en_etat",
    type: "currency",
    category: "Mvt. Fin réelle frais",
    filterable: false,
  },
  mouvement_fin_reelle_frais_rme_definitif: {
    groups: ["bb"],
    title: "Frais RME HT (définitif)",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.frais_remise_en_etat_definitif",
    type: "currency",
    category: "Mvt. Fin réelle frais",
    filterable: false,
  },
  mouvement_fin_reelle_frais_rme_facture: {
    groups: ["bb"],
    title: "Frais RME HT (facturé)",
    badge: "Fin réelle",
    visible: false,
    path: "mouvement_fin_reelle.frais_remise_en_etat_facture",
    type: "currency",
    category: "Mvt. Fin réelle frais",
    filterable: false,
  },

  // === MOUVEMENTS SIMULATION KM (simulation_prorata_km) ===
  mouvement_simulation_prorata_km_date_retour: {
    title: "Date Retour",
    badge: "Sim. km",
    visible: false,
    path: "mouvement_simulation_prorata_km.date_retour",
    type: "date",
    category: "Mvt. Simulation km",
    filterable: false,
  },
  mouvement_simulation_prorata_km_duree: {
    title: "Durée",
    badge: "Sim. km",
    visible: false,
    path: "mouvement_simulation_prorata_km.duree",
    type: "duration",
    category: "Mvt. Simulation km",
    filterable: false,
  },
  mouvement_simulation_prorata_km_km: {
    groups: ["default"],
    title: "Kilométrage",
    badge: "Sim. km",
    visible: false,
    path: "mouvement_simulation_prorata_km.km",
    type: "distance",
    category: "Mvt. Simulation km",
    filterable: false,
  },
  mouvement_simulation_prorata_km_taux_vr: {
    title: "Taux VR",
    badge: "Sim. km",
    visible: false,
    path: "mouvement_simulation_prorata_km.taux_vr",
    type: "percentage",
    category: "Mvt. Simulation km",
    filterable: false,
  },
  mouvement_simulation_prorata_km_montant_vr: {
    title: "Montant VR HT",
    badge: "Sim. km",
    visible: false,
    path: "mouvement_simulation_prorata_km.montant_vr",
    type: "currency",
    category: "Mvt. Simulation km",
    filterable: false,
  },
  mouvement_simulation_prorata_km_valeur_theorique: {
    title: "Valeur Théorique HT",
    badge: "Sim. km",
    visible: false,
    path: "mouvement_simulation_prorata_km.valeur_theorique",
    type: "currency",
    category: "Mvt. Simulation km",
    filterable: false,
  },
  mouvement_simulation_prorata_km_indemnites: {
    title: "Indemnités HT",
    badge: "Sim. km",
    visible: false,
    path: "mouvement_simulation_prorata_km.indemnites",
    type: "currency",
    category: "Mvt. Simulation km",
    filterable: false,
  },
  mouvement_simulation_prorata_km_km_sup: {
    title: "KM Suppl. HT",
    badge: "Sim. km",
    visible: false,
    path: "mouvement_simulation_prorata_km.km_sup",
    type: "currency",
    category: "Mvt. Simulation km",
    filterable: false,
  },

  // === MOUVEMENTS VENTE ===
  // mouvement_vente_date_retour: {
  //   title: "Date Retour",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.date_retour",
  //   type: "date",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // mouvement_vente_duree: {
  //   title: "Durée",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.duree",
  //   type: "duration",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // mouvement_vente_km: {
  //   title: "Kilométrage",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.km",
  //   type: "distance",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // mouvement_vente_taux_vr: {
  //   title: "Taux VR",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.taux_vr",
  //   type: "percentage",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // mouvement_vente_montant_vr: {
  //   title: "Montant VR HT",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.montant_vr",
  //   type: "currency",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // mouvement_vente_valeur_theorique: {
  //   title: "Valeur Théorique HT",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.valeur_theorique",
  //   type: "currency",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // mouvement_vente_indemnites: {
  //   title: "Indemnités HT",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.indemnites",
  //   type: "currency",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // mouvement_vente_km_sup: {
  //   title: "KM Suppl.",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.km_sup",
  //   type: "distance",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // mouvement_vente_frais_remise_en_etat: {
  //   title: "Frais Remise en État HT",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.frais_remise_en_etat",
  //   type: "currency",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // mouvement_vente_cout_remise_en_etat_facture: {
  //   title: "Coût Remise en État Facturé HT",
  //   badge: "Vente",
  //   visible: false,
  //   path: "mouvement_vente.cout_remise_en_etat_facture",
  //   type: "currency",
  //   category: "Mvt. Vente",
  //   filterable: false,
  // },
  // VO
  vo_valeur_theorique: {
    title: "Valeur théorique VO HT",
    visible: false,
    path: "occasion.valeur_theorique",
    type: "currency",
    category: "VO",
    filterable: false,
    editable: true,
  },
  vo_prix_vente: {
    groups: ["bb", "vo"],
    title: "Prix de cession interne HT",
    visible: false,
    visibleVO: true,
    isVO531: true,
    visibleVO531: true,
    isVO: true,
    path: "occasion.prix_de_vente_interne",
    type: "currency",
    category: "VO",
    filterable: false,
    editable: true,
    editableVO: false,
    editableVO531: false,
  },
  vo_prix_vente_interne_ttc: {
    groups: ["vo"],
    title: "Prix de cession interne TTC",
    visible: false,
    visibleVO: true,
    isVO531: true,
    visibleVO531: true,
    isVO: true,
    path: "occasion.prix_de_vente_interne_ttc",
    type: "currency",
    category: "VO",
    filterable: false,
    editable: false,
    editableVO: false,
    editableVO531: false,
  },
  vo_marge_bb: {
    groups: ["vo"],
    title: "Marge BB HT",
    visible: false,
    path: "occasion.marge_buy_back",
    type: "currency",
    category: "VO",
    filterable: false,
  },
  vo_date_vo: {
    groups: ["default", "vo"],
    title: "Date VO",
    visible: false,
    visibleVO: true,
    isVO531: true,
    visibleVO531: true,
    isVO: true,
    path: "occasion.date_vo",
    type: "date",
    category: "VO",
    filterable: {
      filterKey: "date_vo",
      filterType: "date-range",
      placeholder: "Choisissez une période",
    },
    editable: true,
    editableVO: true,
    editableVO531: true,
  },
  vo_prix_vente_propose: {
    groups: ["vo"],
    title: "Prix de vente proposé TTC",
    visible: false,
    visibleVO: true,
    isVO531: false,
    visibleVO531: false,
    isVO: true,
    path: "occasion.prix_de_vente_propose",
    type: "currency",
    category: "VO",
    filterable: false,
    editable: true,
    editableVO: true,
    editableVO531: false,
  },
  vo_prospect: {
    title: "Prospect",
    visible: false,
    visibleVO: true,
    isVO531: false,
    visibleVO531: false,
    isVO: true,
    path: "occasion.prospect",
    type: "text",
    category: "VO",
    filterable: false,
    editable: true,
    editableVO: true,
    editableVO531: false,
  },
  vo_prix_vente_definitif: {
    groups: ["vo"],
    title: "Prix de vente définitif TTC",
    visible: false,
    visibleVO: true,
    isVO531: true,
    visibleVO531: true,
    isVO: true,
    path: "occasion.prix_de_vente_definitif",
    type: "currency",
    category: "VO",
    filterable: false,
    editable: true,
    editableVO: true,
    editableVO531: true,
  },

  vo_date_facture: {
    groups: ["default", "vo"],
    title: "Date facture",
    visible: false,
    visibleVO: true,
    isVO531: true,
    visibleVO531: true,
    isVO: true,
    path: "occasion.date_facture",
    type: "date",
    category: "VO",
    filterable: {
      filterKey: "date_facture",
      filterType: "date-range",
      placeholder: "Choisissez une période",
    },
    // LS-738 : alimentée par l'import de facturation, jamais saisie par les VO
    editable: true,
    editableVO: false,
    editableVO531: false,
  },

  vo_client_facture: {
    title: "Client facture",
    visible: false,
    visibleVO: true,
    isVO531: false,
    visibleVO531: false,
    isVO: true,
    path: "occasion.acheteur",
    type: "text",
    category: "VO",
    filterable: false,
    // LS-738 : alimentée par l'import de facturation, jamais saisie par les VO
    editable: true,
    editableVO: false,
    editableVO531: false,
  },
  vo_prix_vente_facture: {
    groups: ["vo"],
    title: "Prix de vente facturé HT",
    visible: false,
    visibleVO: true,
    isVO531: false,
    visibleVO531: false,
    isVO: true,
    path: "occasion.prix_de_vente_facture",
    type: "currency",
    category: "VO",
    filterable: false,
    // LS-738 : alimentée par l'import de facturation, jamais saisie par les VO
    editable: true,
    editableVO: false,
    editableVO531: false,
  },
  // LS-754 : TTC dérivé du HT par l'API (VP × 1,085, autres types HT = TTC), jamais stocké
  // ni éditable ; mêmes visibilités que la colonne HT qu'elle complète.
  vo_prix_vente_facture_ttc: {
    groups: ["vo"],
    title: "Prix de vente facturé TTC",
    visible: false,
    visibleVO: true,
    isVO531: false,
    visibleVO531: false,
    isVO: true,
    path: "occasion.prix_de_vente_facture_ttc",
    type: "currency",
    category: "VO",
    filterable: false,
    editable: false,
    editableVO: false,
    editableVO531: false,
  },
  vo_marge_brute: {
    groups: ["vo"],
    title: "Marge brute HT",
    visible: false,
    visibleVO: true,
    isVO531: false,
    visibleVO531: false,
    isVO: true,
    path: "occasion.marge_brute",
    type: "currency",
    category: "VO",
    filterable: false,
  },
  // Coût RME avant Marge frais, puis Marge totale : ordre métier transmis par
  // Leasecar (ST1-2146, LS-739), à ne pas réordonner. La marge nette n'est plus
  // affichée (LS-753) mais reste calculée côté API dans la marge totale.
  vo_cout_rme_facture: {
    groups: ["bb"],
    title: "Coût RME facturé HT",
    visible: false,
    visibleVO: true,
    isVO531: true,
    visibleVO531: true,
    isVO: true,
    path: "occasion.cout_remise_en_etat_facture",
    type: "currency",
    category: "VO",
    filterable: false,
    editable: true,
    editableVO: true,
    editableVO531: true,
  },
  vo_marge_frais: {
    groups: ["vo"],
    title: "Marge frais HT",
    visible: false,
    visibleVO: true,
    isVO531: false,
    visibleVO531: false,
    isVO: true,
    path: "occasion.marge_frais",
    type: "currency",
    category: "VO",
    filterable: false,
  },
  vo_marge_totale_leasecar: {
    groups: ["vo"],
    title: "Marge totale Leasecar HT",
    visible: false,
    path: "occasion.marge_totale",
    type: "currency",
    category: "VO",
    filterable: false,
  },
  vo_commission: {
    groups: ["vo"],
    title: "Commission TTC",
    visible: false,
    visibleVO: false,
    isVO531: false,
    visibleVO531: false,
    isVO: true,
    path: "occasion.commission",
    type: "currency",
    category: "VO",
    filterable: false,
    editable: true,
    editableVO: false,
    editableVO531: false,
  },
};
